import { render, staticRenderFns } from "./Edit-Department-Loading.vue?vue&type=template&id=19197149&"
import script from "./Edit-Department-Loading.vue?vue&type=script&lang=js&"
export * from "./Edit-Department-Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports